"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ellipse = void 0;
const gl_matrix_1 = require("gl-matrix");
/**
 * Ellipse Shape
 */
class Ellipse {
    /**
     * Private constructor, use static creation methods instead.
     */
    constructor(center, radiusX, radiusY) {
        this.center = center;
        this.radiusX = radiusX;
        this.radiusY = radiusY;
    }
    /**
     * Creates an Ellipse instance described by the circle JSON.
     */
    static fromJson(json) {
        return new Ellipse(gl_matrix_1.vec2.fromValues(json.Center[0], json.Center[1]), json.RadiusX, json.RadiusY);
    }
    /**
     * Creates an JSON object out of the Ellipse instance.
     */
    toJson() {
        return {
            Center: [this.center[0], this.center[1]],
            RadiusX: this.radiusX,
            RadiusY: this.radiusY,
        };
    }
    /**
     * Test if the point is inside the circle or on the circle contour.
     */
    isPointInShape() {
        // todo EKE-7650
        return true;
    }
    /**
     * Transform the Ellipse by the given matrix.
     */
    transform(transform) {
        const transformedCenter = gl_matrix_1.vec2.create();
        gl_matrix_1.vec2.transformMat2d(transformedCenter, this.center, transform);
        const scaleX = transform[0];
        const transformedRadiusX = this.radiusX * scaleX;
        // todo EKE-7650 verify that index 3 == scaleY
        const scaleY = transform[3];
        const transformedRadiusY = this.radiusY * scaleY;
        return new Ellipse(transformedCenter, transformedRadiusX, transformedRadiusY);
    }
}
exports.Ellipse = Ellipse;
//# sourceMappingURL=Ellipse.js.map